import { createFileRoute } from '@tanstack/react-router';
import { PlanGuard } from '@/components/guards';
import { GoalsListRouteView } from '@/pages/workspaces/goals/routing';
import { BUILDER_PLAN_SLUG } from '@/services/auth/plan-slugs';
import { LastWorkspaceResolver } from './-components';
import { ShowGoalsGate } from './-goals-route';

function GoalsRoute() {
  return (
    <LastWorkspaceResolver>
      <ShowGoalsGate>
        <PlanGuard excludedPlans={[BUILDER_PLAN_SLUG]}>
          <GoalsListRouteView />
        </PlanGuard>
      </ShowGoalsGate>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/goals/')({
  component: GoalsRoute,
});
